// InputCheckbox.js
import { Label } from "./label";
import { Error } from "./error";

export const InputCheckbox = ({
  name,
  label,
  labelClassName,
  error,
  registration,
  className,
  ...props
}) => (
  <div className="mb-3">
    <div className="my-cb-input-container">
      <input
        id={name}
        type="checkbox"
        className={`${className || ""}`}
        {...registration}
        {...props}
      />
      <Label
        className={`${labelClassName || ""}`}
        htmlFor={name}
      >
        {label}
      </Label>
    </div>
    <Error errorMessage={error?.message} />
  </div>
);
